<template>
    <v-card class="co-novo-documento-signatario-card-dados-principais pa-4">
        <v-card-text class="pa-0">
            <tipo-assinatura
                :signatario="signatario"
                :exibir-signatario-completo="exibirSignatarioCompleto"
                :tipos-assinatura="tiposAssinatura"
                @validaTipoWhatsapp="validaTipoWhatsapp"
            />

            <div :class="exibirSignatarioCompleto ? '' : 'dado-principal'">
                <email-signatario-novo
                    v-if="signatario.tipoAssinatura !== 'WHATSAPP'"
                    v-model="signatario"
                    :signatarios-sugestoes="signatariosSugestoes"
                    campo-requerido
                    descricao/>

                <telefone-signatario-novo
                    v-if="signatario.tipoAssinatura === 'WHATSAPP'"
                    v-model="signatario"
                    campo-requerido
                    descricao/>

                <template v-if="!exibirSignatarioCompleto">
                    <v-spacer/>

                    <v-btn icon :disabled="podeExcluirSignatario"
                           @click="remover(signatario)">
                        <v-icon size="22"> mdi-delete </v-icon>
                    </v-btn>
                </template>
            </div>

            <v-card-actions v-show="exibirSignatarioCompleto" class="mt-2 py-0">
                <papel-signatario-novo
                    v-model="signatario"
                    :papeis="papeisSignatario"
                    campo-requerido
                    descricao/>

                <v-spacer/>

                <v-btn icon :disabled="podeExcluirSignatario"
                       @click="remover(signatario)">
                    <v-icon size="22"> mdi-delete </v-icon>
                </v-btn>
            </v-card-actions>
            <v-divider class="mt-3"/>
        </v-card-text>

        <v-expansion-panels class="autenticacoes-avancadas-expansion" flat v-model="exibirAutenticacoesAvancadas">
            <v-expansion-panel>
                <v-expansion-panel-header class="px-2">
                    <span class="opcoes-avancadas-titulo">Autenticações avançadas</span>
                    <template v-slot:actions>
                        <v-icon color="primary"> mdi-chevron-down </v-icon>
                    </template>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <div class="py-0 px-2 d-flex observador-wrapper">
                        <div class="d-flex align-center observador">
                            <span class="observador-label">Definir como observador</span>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on" class="definir-ordem-tooltip">
                                        <v-icon size="13px"> mdi-information </v-icon>
                                    </span>
                                </template>
                                <span>O e-mail informado não assinará o {{ $tc("pt_br.documento").toLowerCase() }}. Receberá apenas uma notificação quando o {{ $tc("pt_br.documento").toLowerCase() }} for formalizado.</span>
                            </v-tooltip>
                        </div>

                        <v-switch
                            class="ma-0 pa-0"
                            color="primary"
                            dense
                            hide-details
                            @change="alternarObservador"
                            v-model="signatario.observador"
                            :disabled="!signatario.email"
                        />
                    </div>

                    <div class="mt-4 py-0 px-2 d-flex solicitar-token-wrapper">
                        <div class="d-flex align-center solicitar-token">
                            <span class="solicitar-token-label">Solicitar token de verificação enviado por e-mail</span>
                        </div>

                        <v-switch
                            class="ma-0 pa-0"
                            color="primary"
                            dense
                            hide-details
                            v-model="signatario.exigirTokenValidacao"
                            :disabled="ehPlanoFree"
                        />
                    </div>

                    <div class="mt-4 py-0 px-2 d-flex solicitar-telefone-wrapper">
                        <div class="d-flex align-center solicitar-telefone">
                            <span class="solicitar-telefone-label">Solicitar telefone na assinatura</span>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on" class="definir-ordem-tooltip">
                                        <v-icon size="13px"> mdi-information </v-icon>
                                    </span>
                                </template>
                                <span>O telefone será solicitado para conclusão de assinatura do {{ $tc("pt_br.documento").toLowerCase() }}.</span>
                            </v-tooltip>
                        </div>

                        <v-switch
                            class="ma-0 pa-0"
                            color="primary"
                            dense
                            hide-details
                            v-model="signatario.solicitarTelefoneAssinatura"
                            :disabled="signatario.observador"
                        />
                    </div>

                    <div class="mt-4 py-0 px-2 d-flex solicitar-telefone-wrapper">
                        <div class="d-flex align-center solicitar-telefone">
                            <span class="solicitar-telefone-label">Solicitar selfie</span>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on" class="definir-ordem-tooltip">
                                        <v-icon size="13px"> mdi-information </v-icon>
                                    </span>
                                </template>
                                <span>Solicitará obrigatoriamente ao {{ $tc("pt_br.signatario").toLowerCase() }} tirar uma selfie para conclusão da assinatura.</span>
                            </v-tooltip>
                        </div>

                        <v-switch
                            class="ma-0 pa-0"
                            color="primary"
                            dense
                            hide-details
                            v-model="signatario.solicitarSelfieAssinatura"
                            :disabled="signatario.observador"
                        />
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>


    </v-card>
</template>

<script>
import EmailSignatarioNovo
    from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/EmailSignatarioNovo'
import PapelSignatarioNovo
    from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/PapelSignatarioNovo'
import TelefoneSignatarioNovo
    from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/TelefoneSignatarioNovo'
import TipoAssinatura
    from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/TipoAssinatura'
import {mapGetters} from 'vuex'

export default {
    name: 'CardDadosPrincipais',
    components: {
        TipoAssinatura,
        EmailSignatarioNovo, PapelSignatarioNovo, TelefoneSignatarioNovo
    },
    props: {
        exibirSignatarioCompleto: {
            type: Boolean,
            default: true
        },
        podeExcluirSignatario: {
            type: Boolean,
            default: false
        },
        podeAdicionarObservador: {
            type: Boolean
        },
        signatario: {
            required: true,
            type: Object
        },
        signatariosSugestoes: {
            type: Array,
        },
        papeisSignatario: {
            type: Array
        },
        tiposAssinatura: {
            type: Array
        },
        posicaoSignatario: {
            type: Number
        }
    },
     data() {
        return {
            exibirAutenticacoesAvancadas: false
        }
    },
    computed: {
        ...mapGetters(['ehPlanoFree']),
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        }
    },
    methods: {
        alternarObservador() {
            if (this.signatario.observador) {
                this.$emit('alternar-observador', {posicaoSignatario: this.posicaoSignatario, signatario: this.signatario})
            }
        },
        remover() {
            this.$emit('remover', this.signatario)
        },
        validaTipoWhatsapp() {
            this.$emit('validaTipoAssinatura')
        }
    }
}
</script>

<style lang="stylus">
.co-novo-documento-signatario-card-dados-principais
    .dado-principal
        display flex

    .co-tipo-assinatura-novo
        .v-input__control
            .v-input__slot
                height 35px
                min-height unset

            .v-input__append-inner
                margin-top 5px

            .v-select__selections
                font-size 13px
                font-weight 400

    .autenticacoes-avancadas-expansion
        .opcoes-avancadas-titulo
            color var(--primary)

        .v-expansion-panel-header
            padding 0
            min-height 35px !important
            height 35px
            margin-top 12px

        .v-expansion-panel-content
            .v-expansion-panel-content__wrap
                padding 0
                margin-top 10px

    .observador-wrapper
    .solicitar-token-wrapper
    .solicitar-telefone-wrapper
        justify-content space-between

        .observador
        .solicitar-token
        .solicitar-telefone
            gap 5px

            .observador-label
            .solicitar-token-label
            .solicitar-telefone-label
                color var(--text-color-300)
                font-size 14px

</style>
